import { BezierLineMarkerController } from '../bezier/bezierLineMarkerController'
import { MarkerModes } from '../../types'

class MeasurementMarkerController extends BezierLineMarkerController {
  constructor(marker) {
    super(marker)
  }

  mousePressedEvent(): void {
    const marker = this.marker
    const state = marker.state
    super.mousePressedEvent()
    if (state.mode === MarkerModes.Create && !state.pressedHandle && state.anchorPoints.length === 2) {
      state.mode = MarkerModes.Edit
      marker.markerCreatedCallback(marker)
    }
  }
}

export { MeasurementMarkerController }
